import { render, staticRenderFns } from "./ViewLive.vue?vue&type=template&id=7ecb1124&"
import script from "./ViewLive.vue?vue&type=script&lang=js&"
export * from "./ViewLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports